module.exports = __webpack_public_path__ + "img/fy.f3b9cd6f.png";